<script lang="ts">
	import Table from '#lib/components/Table.svelte';
	import _ from 'lodash';
	import type {
		HDFieldPlayer,
		HDGameReportResponseData,
		HDGoal,
		HDPenalty
	} from '../types/responses/GameReport.js';
	import type { HDExtraData } from '../types/util/ExtraData.js';
	import type { TableCol } from '../types/util/TableCol.js';
	import CollapsibleCard from '#lib/components/CollapsibleCard.svelte';

	let {
		game
	}: {
		game: HDGameReportResponseData;
	} = $props();

	const penaltyCols: TableCol[] = $state([
		{
			key: 'gameTimePeriod',
			label: 'Per',
			sortable: true,
			tooltip: 'Spielabschnitt',
			tooltipClass: 'tooltip-right'
		},
		{
			key: 'gameTimeFormatted',
			label: 'Zeit',
			sortable: true
		},
		{
			key: 'extraData.team',
			label: 'Team',
			sortable: true
		},
		{
			key: 'offender',
			label: 'Spieler',
			sortable: true,
			sortFunction: (o: HDExtraData<HDFieldPlayer>) => `${o.playerLastname} ${o.playerFirstname}`,
			class: 'justify-start'
		},
		{
			key: 'penaltyLength',
			label: 'PIM',
			sortable: true,
			tooltip: 'Strafminuten'
		},
		{
			key: 'offence',
			label: 'Vergehen',
			sortable: true,
			class: 'justify-start'
		}
	]);

	const penalties = $derived.by<HDExtraData<HDPenalty>[]>(() =>
		game
			? [
					...game.homePenalties.map(
						(penalty: HDPenalty): HDExtraData<HDPenalty> => ({
							id: penalty.guid,
							extraData: {
								team: game.gameData.homeTeamShortname
							},
							...penalty
						})
					),
					...game.awayPenalties.map(
						(penalty: HDPenalty): HDExtraData<HDPenalty> => ({
							id: penalty.guid,
							extraData: {
								team: game.gameData.awayTeamShortname
							},
							...penalty
						})
					)
				].sort((a, b) => a.gameTime - b.gameTime)
			: []
	);
</script>

<CollapsibleCard title="Strafen" open>
	<Table columns={penaltyCols} rows={penalties}>
		{#snippet headers(column)}
			{#if column.key === 'offender'}
				<div class="flex flex-row items-center">
					<span class="text-accent block w-8 pr-2 text-right">#</span> Spieler
				</div>
			{:else}
				<div>{column.label}</div>
			{/if}
		{/snippet}

		{#snippet data(row, col, getRowData)}
			{#if col.key === 'offender'}
				<div class="flex flex-row items-center">
					<span class="text-accent block w-8 pr-2 text-right">{row.offender.playerJerseyNr}</span>
					{row.offender.playerLastname}&nbsp;{row.offender.playerFirstname.charAt(0)}
				</div>
			{:else if col.key === 'penaltyLength'}
				{row.penaltyLength / 60}
			{:else if col.key === 'offence'}
				<div class="flex justify-start">
					{row.offence}
				</div>
			{:else}
				{getRowData(row, col.key)}
			{/if}
		{/snippet}
	</Table>
</CollapsibleCard>
